<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出帳戶註冊？"></QuitButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="設定密碼"></MainTitle>
      <InputBox text="手提電話號碼" :value="showMobile" hideInput="true"></InputBox>
      <InputBox text="密碼" placeholder="6-18位英文或數字或符號" type="password" @getValue="getPasswordValue"></InputBox>
      <InputBox text="確認密碼" placeholder="請再次輸入密碼" type="password" @getValue="getConfirmPasswordValue"></InputBox>
      <ConfirmButton text="註冊" position="relative" @click="setPassword"></ConfirmButton>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import QuitButton from "../components/common/QuitButton";
import {alertController} from "@ionic/vue";
import InputBox from "../components/common/InputBox";

export default {
  name: "SetPassword",
  components: {
    InputBox,
    QuitButton,
    ConfirmButton,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      mobile: '',
      showMobile: '',
      password: '',
      confirmPassword: '',
    }
  },
  mounted() {
    this.mobile = this.$route.params.mobile;
    this.showMobile = common.splitMobile(this.mobile)
  },
  methods: {
    getPasswordValue: function (value) {
      this.password = value;
    },
    getConfirmPasswordValue: function (value) {
      this.confirmPassword = value;
    },
    setPassword: function() {
      if (this.password.trim().length === 0) {
        common.showAlert('請輸入密碼。')
        return false;
      }
      if (this.confirmPassword.trim().length === 0) {
        common.showAlert('請確認密碼。')
        return false;
      }
      if (this.password !== this.confirmPassword) {
        common.showAlert('密碼不一致，請重新輸入。')
        return false;
      }
      const loading = common.showLoading();
      common.apiPostData('/setPassword', {mobile: this.mobile, password: this.password, confirm_password: this.confirmPassword}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        // 电话号码已经被注册，提供用户名注册方式
        if (res.other_register) {
          const confirm = alertController.create({
            cssClass: 'alert',
            header: '電話號碼已被註冊',
            message: '您所輸入的電話號碼已被註冊。<br>' +
                '<br>'+
                '您可輸入其他手提電話號碼進行註冊。',
            mode: 'ios',
            backdropDismiss: false,
            buttons: [
              {
                text: '其他手提電話號碼註冊',
                handler: () => {
                  router.replace('/register')
                  return;
                }
              },
              // {
              //   text: '用戶名稱註冊',
              //   handler: () => {
              //     router.replace('/registerName/'+this.mobile)
              //     return
              //   }
              // },
              {
                text: '取消',
                // handler: () => {
                //
                // }
              },
            ]
          }).then(response => {
            response.present();
          });
          return false;
        }

        router.replace('/login')
      })
    }
  }
}
</script>

<style scoped>

</style>
